<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            
            <b-col md="3">
              <b-form-group>
                <label>Proposal No</label>
                <input
                        type="text"
                        class="form-control form-control-lg"
                        placeholder="ENTER PROPOSAL NO"
                        v-model="proposal_number"
                        @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group>
                <label>Vehicle No</label>
                <input
                        type="text"
                        class="form-control form-control-lg"
                        placeholder="Enter Vehicle No"
                        v-model="vehicle_number"
                        @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group>
                <label>User</label>
                <v-select
                        :options="user_accounts"
                        v-model="user_account"
                        :reduce="data => data.id"
                        label="name"
                        hide-details
                        placeholder="--PLEASE SELECT--"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group>
                <label>Status</label>
                <v-select
                        :options="proposal_status_list"
                        v-model="proposal_status"
                        :reduce="data => data.code"
                        label="name"
                        placeholder="--PLEASE SELECT--"
                ></v-select>
              </b-form-group>
            </b-col>


            <b-col md="3">
              <b-form-group>
                <label>Date</label>
                <input type="date" v-model="date" class="form-control form-control-lg">
              </b-form-group>
            </b-col>

          </b-row>

          <div slot="footer" class="search-panel-btn">
            <b-button
                    type="submit"
                    size="sm"
                    variant="primary"
                    class="search-btn"
                    @click="doFilter"
            ><i class="cui-magnifying-glass icons"></i> Search</b-button
            >
            <b-button
                    type="reset"
                    size="sm"
                    variant="danger"
                    @click="resetFilter"
            ><i class="cui-ban icons"></i> Reset</b-button
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"; 
export default { 
  data() {
    return {
      insured_name: "",
      proposal_number: "",
      vehicle_number:"",
      insurance_type:"",
      user_accounts:[],
      user_account: "",
      date:'',
      proposal_status:'',
    };
  }, 
  methods: {
    ...mapActions("user", [
      "getSystemUsers",
      "getParameterDataList",
      "getFilteredUsers"
    ]),
    ...mapActions("proposal", [
      "getParameterDataList"
    ]),
    async userList() {
      await this.getFilteredUsers();
      this.user_accounts = this.filter_user_list;
    },
    doFilter() {
      let filters = {
        proposal_status: this.proposal_status,
        proposal_number:this.proposal_number,
        vehicle_number:this.vehicle_number,
        user_account: this.user_account,
        date: this.date
      };
      this.$events.fire("filter-set", filters);
    },
    resetFilter() {
      this.proposal_status = "";
      this.proposal_number = "";
      this.vehicle_number = "";
      this.user_account = "";
      this.date = "";
      this.$events.fire("filter-reset");
    },
    async getProposalStatusList() {
      let table = 'proposal_status';
      const data = {
        table: table,
        type: 'proposal_status_list'
      };
      await this.getParameterDataList(data);
    },
  },
  computed: {
    ...mapState("user", ["system_user_list" , "filter_user_list"]),
    ...mapState("proposal", ["proposal_status_list"]),
    ...mapState("login" , ["user_id"])
  },
  mounted(){
    this.userList();
    this.getProposalStatusList();
  }
};
</script>

<style scoped>
.search-panel-btn {
  float: right;
}

.search-btn {
  margin-right: 5px;
}
input::placeholder {
  font-size: 14px;
}

</style>
